
const digest = 'c344b56b758e89bfbfdeb37c04c92e003d68c9703302810c990cb3b892249b32';
const classes = {"container":"_container_6kgvv_1","number":"_number_6kgvv_8"};
const css = `._container_6kgvv_1 {
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
}

._number_6kgvv_8 {
  flex: 1;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  